var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDiscord(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 25,
    viewBox: "0 0 31 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.74268 18.2583C13.5169 21.6454 17.5814 21.6454 24.3556 18.2583",
    stroke: "currentColor",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.2913 20.2903L21.6461 23C21.6461 23 27.2971 21.2008 29.0977 18.2581C29.0977 16.9032 29.8158 7.22019 25.0332 4.03226C23.0009 2.67742 19.6138 2 19.6138 2L18.259 4.70968H15.5493",
    stroke: "currentColor",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8447 20.2903L9.48991 23C9.48991 23 3.83888 21.2008 2.0383 18.2581C2.0383 16.9032 1.32023 7.22019 6.10281 4.03226C8.13507 2.67742 11.5222 2 11.5222 2L12.877 4.70968H15.5867",
    stroke: "currentColor",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8072 15.5483C9.68535 15.5483 8.7749 14.3357 8.7749 12.8386C8.7749 11.3415 9.68535 10.1289 10.8072 10.1289C11.929 10.1289 12.8394 11.3415 12.8394 12.8386C12.8394 14.3357 11.929 15.5483 10.8072 15.5483ZM20.291 15.5483C19.1692 15.5483 18.2588 14.3357 18.2588 12.8386C18.2588 11.3415 19.1692 10.1289 20.291 10.1289C21.4128 10.1289 22.3233 11.3415 22.3233 12.8386C22.3233 14.3357 21.4128 15.5483 20.291 15.5483Z",
    stroke: "currentColor",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscord);
export default __webpack_public_path__ + "static/media/discord.92846128548396d15e8ae951e0808c82.svg";
export { ForwardRef as ReactComponent };